import React from 'react';

import classnames from 'classnames';

import { TypographVariant, Typography, TypographySize } from '../Typography/Typography';
import styles from './Title.module.css';

export type Props = {
  className?: string;
  component?: string;
  dataTau?: string;
  defaultPadding?: boolean;
  defaultVerticalPadding?: boolean;
  id?: string;
  isRedeem?: boolean;
  isSeparatorHidden?: boolean;
  separatorClassName?: string;
  subTitle?: string | null | JSX.Element;
  subTitleClassName?: string;
  title?: string | JSX.Element;
  titleClassName?: string;
  variant?: TypographVariant;
  variantSize?: TypographySize;
};

export const Title = React.memo((props: Props) => {
  const {
    title,
    subTitle,
    titleClassName,
    subTitleClassName,
    separatorClassName,
    className,
    id,
    defaultPadding,
    defaultVerticalPadding,
    variant = 'h2',
    component,
    variantSize,
    isSeparatorHidden,
    isRedeem,
    dataTau,
  } = props;

  return (
    <div id={id} className={classnames({
      [styles.wrapper]: defaultPadding,
      [styles.verticalWrapper]: defaultVerticalPadding,
      [styles.redeemWrapper]: isRedeem,
    }, className)}>
      {title && (
        <Typography
          dataTau={dataTau}
          component={component}
          className={classnames(
            styles.title,
            titleClassName,
            { [styles.withSubTitle]: !!subTitle },
          )}
          variant={variant}
          size={variantSize}
        >
          {title}
        </Typography>
      )}

      {subTitle && (
        <Typography className={classnames(styles.subTitle, subTitleClassName)}>
          {subTitle}
        </Typography>
      )}

      {!isSeparatorHidden && (
        <div className={classnames(
          styles.seperator,
          separatorClassName,
        )} />
      )}
    </div>
  );
});

Title.displayName = 'Title';
